import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class CvePocAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'cvepoc';

	getContent(file) {
		let request = {
			url: `${this.getAPIUrl()}/content?file=${file}`
		};

		return httpClient.getAsync(request);
	}

	sync() {
		let request = {
			url: `${this.getAPIUrl()}/sync`
		};

		return httpClient.postAsync(request);
	}
}

export default new CvePocAPI();
